import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';

import { viewModes } from 'App/components/Assessments/constants';
import { StyledTooltip } from 'App/components/PatientPredictiveModelRisk/styles';
import SafeHtmlOnly from 'App/components/SafeHtmlOnly/SafeHtmlOnly';
import { patientPropType } from 'Shared/types';
import { questionPropType, scorePropType } from '../types';
import DisplayCMSContent from './DisplayCMSContent';

function getBaseQuestionText(question, mode) {
    if (question) {
        switch (mode.label) {
            case viewModes.VIEW_FULLY_SCRIPTED: {
                return question.question;
            }
            case viewModes.VIEW_COMPACT: {
                return question.compactQuestion || question.question;
            }
            case viewModes.VIEW_MOBILE: {
                return question.mobileQuestion || question.question;
            }
            default:
                return question.question;
        }
    }
}

const AssessmentQuestionText = ({ question, viewMode, patient, score, showRequiredAsterisk }) => {
    const baseQuestionText = getBaseQuestionText(question, viewMode);
    const endOfLineContent = useMemo(
        () => (
            <React.Fragment key={`question-end-of-line-content-${question.questionId}`}>
                {!showRequiredAsterisk ? null : <span className="required-asterisk"> * </span>}
                {!question.attributes.extra_info ? null : (
                    <OverlayTrigger
                        overlay={
                            <StyledTooltip id={`question-tooltip-${question.questionId}`}>
                                <SafeHtmlOnly>{question.attributes.extra_info}</SafeHtmlOnly>
                            </StyledTooltip>
                        }
                    >
                        <FaInfoCircle className="text-primary" />
                    </OverlayTrigger>
                )}
            </React.Fragment>
        ),
        [question.questionId, question.attributes.extra_info, showRequiredAsterisk]
    );

    return (
        <span className="markdown-contents">
            <DisplayCMSContent
                content={baseQuestionText}
                patient={patient}
                score={score}
                endOfLineContent={endOfLineContent}
            />
        </span>
    );
};

AssessmentQuestionText.propTypes = {
    question: questionPropType.isRequired,
    viewMode: PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    }),
    patient: patientPropType,
    score: scorePropType,
    showRequiredAsterisk: PropTypes.bool,
};

AssessmentQuestionText.defaultProps = {
    patient: null,
    score: null,
    viewMode: null,
    showRequiredAsterisk: false,
};

export default AssessmentQuestionText;
